var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3702_27542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.8125 7.5V19C0.8125 20.1046 1.70793 21 2.8125 21H23.1875C24.2921 21 25.1875 20.1046 25.1875 19V7.5M2.8125 7.5H23.1875C24.2921 7.5 25.1875 6.60457 25.1875 5.5V5C25.1875 3.89543 24.2921 3 23.1875 3H2.8125C1.70793 3 0.8125 3.89543 0.8125 5V5.5C0.8125 6.60457 1.70793 7.5 2.8125 7.5Z",
    stroke: "#2CB3A5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6875 11.25H20.3125M5.6875 14.25H20.3125M5.6875 17.25H13.8125",
    stroke: "#2CB3A5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 5.99997C4.16421 5.99997 4.5 5.69002 4.5 5.30766C4.5 4.92531 4.16421 4.61536 3.75 4.61536C3.33579 4.61536 3 4.92531 3 5.30766C3 5.69002 3.33579 5.99997 3.75 5.99997Z",
    fill: "#2CB3A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59375 5.99997C7.00796 5.99997 7.34375 5.69002 7.34375 5.30766C7.34375 4.92531 7.00796 4.61536 6.59375 4.61536C6.17954 4.61536 5.84375 4.92531 5.84375 5.30766C5.84375 5.69002 6.17954 5.99997 6.59375 5.99997Z",
    fill: "#2CB3A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4375 5.99997C9.85171 5.99997 10.1875 5.69002 10.1875 5.30766C10.1875 4.92531 9.85171 4.61536 9.4375 4.61536C9.02329 4.61536 8.6875 4.92531 8.6875 5.30766C8.6875 5.69002 9.02329 5.99997 9.4375 5.99997Z",
    fill: "#2CB3A5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3702_27542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocSupport);
export default __webpack_public_path__ + "static/media/docSupport.3a91338f.svg";
export { ForwardRef as ReactComponent };